import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query'
import { getPartnerPaymentRecords } from '../../services'
import { PartnerQueryKeys } from '@/modules/manage-player/keys'
import { GetPartnerPaymentRecordsResponse } from '@/modules/manage-player/type'

interface GetPartnerPaymentRecordsPayload {
	skip?: number
	take?: number
}

export default function useQueryGetPartnerPaymentRecords(
	partnerId: string,
	payload?: GetPartnerPaymentRecordsPayload,
	props?: UseBaseQueryOptions<GetPartnerPaymentRecordsResponse>,
) {
	return useQuery({
		queryKey: [PartnerQueryKeys.GetPartnerPaymentRecords, partnerId, payload],
		queryFn: () => getPartnerPaymentRecords(partnerId, payload),
		enabled: !!partnerId,
		...props,
	})
}
